import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages", "input", "form", "submitButton"]
  static values = { chatId: Number }

  connect() {
    this.historyIndex = -1
    this.draftMessage = ""
    this.scrollToBottom()
    this.observeNewMessages()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleKeyDown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      if (this.inputTarget.value.trim() !== "") {
        this.historyIndex = -1
        this.draftMessage = ""
        this.formTarget.requestSubmit()
      }
      return
    }

    if (event.key === "ArrowUp" && this.isAtInputStart()) {
      event.preventDefault()
      this.navigateHistory(1)
    } else if (event.key === "ArrowDown" && this.isAtInputEnd()) {
      event.preventDefault()
      this.navigateHistory(-1)
    }
  }

  onSubmitEnd() {
    this.inputTarget.value = ""
    this.inputTarget.style.height = "auto"
    this.scrollToBottom()
  }

  autoResize(event) {
    const textarea = event.target
    textarea.style.height = "auto"
    textarea.style.height = Math.min(textarea.scrollHeight, 200) + "px"
  }

  scrollToBottom() {
    if (this.hasMessagesTarget) {
      requestAnimationFrame(() => {
        this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
      })
    }
  }

  observeNewMessages() {
    if (!this.hasMessagesTarget) return

    this.observer = new MutationObserver(() => {
      this.scrollToBottom()
    })

    this.observer.observe(this.messagesTarget, {
      childList: true,
      subtree: true,
      characterData: true
    })
  }

  // -- Prompt history --

  getUserMessages() {
    if (!this.hasMessagesTarget) return []
    const nodes = this.messagesTarget.querySelectorAll('[data-role="user"]')
    return Array.from(nodes).map(el => el.textContent.trim())
  }

  navigateHistory(direction) {
    const history = this.getUserMessages()
    if (history.length === 0) return

    if (this.historyIndex === -1 && direction === 1) {
      this.draftMessage = this.inputTarget.value
    }

    const newIndex = this.historyIndex + direction
    if (newIndex >= history.length || newIndex < -1) return

    this.historyIndex = newIndex

    if (this.historyIndex === -1) {
      this.inputTarget.value = this.draftMessage
    } else {
      this.inputTarget.value = history[history.length - 1 - this.historyIndex]
    }

    this.resizeInput()
  }

  isAtInputStart() {
    return this.inputTarget.selectionStart === 0 && this.inputTarget.selectionEnd === 0
  }

  isAtInputEnd() {
    const len = this.inputTarget.value.length
    return this.inputTarget.selectionStart === len && this.inputTarget.selectionEnd === len
  }

  resizeInput() {
    this.inputTarget.style.height = "auto"
    this.inputTarget.style.height = Math.min(this.inputTarget.scrollHeight, 200) + "px"
  }
}
